
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 16A16 16 0 1016 0 16 16 0 000 16z","fill":"#f7fafc"}}),_c('path',{attrs:{"d":"M23.452 9.238h-1.619l.91-1.377a.67.67 0 00-.191-.93l-1-.661a.67.67 0 00-.93.191l-1.837 2.78h-5.284l-2.153-2.942a.673.673 0 00-.939-.145l-.969.709a.673.673 0 00-.145.939l1.052 1.436H8.524a2.949 2.949 0 00-2.949 2.949V22.1a2.949 2.949 0 002.949 2.949h14.93a2.949 2.949 0 002.949-2.949v-9.912a2.947 2.947 0 00-2.951-2.95zM19.8 17.917l-5.47 3.158a.7.7 0 01-1.047-.605v-6.316a.7.7 0 011.047-.605l5.47 3.158a.7.7 0 010 1.21z","fill":"#acaebe"}})])
          )
        }
      }
    